/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { QuotePunchoutDetailsResource } from './';
import {
    QuotePunchoutDetailsResourceFromJSON,
    QuotePunchoutDetailsResourceFromJSONTyped,
    QuotePunchoutDetailsResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuotePunchoutResource
 */
export interface QuotePunchoutResource {
    /**
     * 
     * @type {boolean}
     * @memberof QuotePunchoutResource
     */
    enabled: boolean;
    /**
     * 
     * @type {QuotePunchoutDetailsResource}
     * @memberof QuotePunchoutResource
     */
    details?: QuotePunchoutDetailsResource;
}

/**
 * Check if a given object implements the QuotePunchoutResource interface.
 */
export function instanceOfQuotePunchoutResource(value: object): value is QuotePunchoutResource {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function QuotePunchoutResourceFromJSON(json: any): QuotePunchoutResource {
    return QuotePunchoutResourceFromJSONTyped(json, false);
}

export function QuotePunchoutResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuotePunchoutResource {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'details': json['details'] == null ? undefined : QuotePunchoutDetailsResourceFromJSON(json['details']),
    };
}

export function QuotePunchoutResourceToJSON(value?: QuotePunchoutResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'enabled': value['enabled'],
        'details': QuotePunchoutDetailsResourceToJSON(value['details']),
    };
}

